module.exports = __webpack_public_path__ + "static/media/ticketing.fa9cc929.png";